import { FileText } from "lucide-react";
import { CollapsibleCard } from "../CollapsibleCard";

interface SprinklerProtectionSectionProps {
  submission: any;
  defaultOpen?: boolean;
}

export const SprinklerProtectionSection = ({
  submission,
  defaultOpen = false,
}: SprinklerProtectionSectionProps) => {
  return (
    <CollapsibleCard
      title="6. Sprinkler & Fire Protection"
      defaultOpen={defaultOpen}
    >
      <div className="space-y-3 md:space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Building Height
            </span>
            <span className="text-sm font-medium">
              {submission.buildingHeight} ft
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Sprinkler System Type
            </span>
            <span className="text-sm font-medium">
              {submission.sprinklerSystemType}
            </span>
          </div>
          {submission.sprinklerSystemType === "esfr" &&
            submission.kFactorPsi && (
              <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
                <span className="text-sm font-medium text-muted-foreground">
                  K-Factor/PSI
                </span>
                <span className="text-sm font-medium">
                  {submission.kFactorPsi}
                </span>
              </div>
            )}
          {submission.sprinklerSystemType === "cmsa" &&
            submission.kFactorPsi && (
              <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
                <span className="text-sm font-medium text-muted-foreground">
                  K-Factor/PSI
                </span>
                <span className="text-sm font-medium">
                  {submission.kFactorPsi}
                </span>
              </div>
            )}
          {submission.sprinklerSystemType === "cmda" &&
            submission.densityRequirement && (
              <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
                <span className="text-sm font-medium text-muted-foreground">
                  Density Requirement
                </span>
                <span className="text-sm font-medium">
                  {submission.densityRequirement}
                </span>
              </div>
            )}
          {submission.files?.sprinklerInfo &&
            submission.files.sprinklerInfo.length > 0 && (
              <div className="space-y-2 md:col-span-2">
                <span className="text-sm font-medium text-muted-foreground">
                  Sprinkler Info Documents
                </span>
                <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:gap-4">
                  {submission.files.sprinklerInfo.map(
                    (file: any, index: number) => (
                      <a
                        key={index}
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                      >
                        <FileText className="mr-2 h-4 w-4" />
                        {file.name}
                      </a>
                    )
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </CollapsibleCard>
  );
};
